/*
FPLink: A Link styled like an FPButton, but functioning like a React Router <Link>.
Props:
- to: The route to navigate to
- text: The button's text
- icon: The icon's name (optional, same as FPButton)
- theme: 'light' or 'dark'
- background, textColor, outlined, width: Same as FPButton

By: Efraín A.
*/

import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const FPLink = ({
  to,
  text = "Text",
  icon,
  theme = "light",
  background,
  textColor,
  outlined = true,
  width = "10rem",
  ...rest
}) => {
  return (
    <StyledLink
      to={to}
      themeStyle={theme}
      background={background}
      textColor={textColor}
      outlined={outlined}
      width={width}
      {...rest}
    >
      {icon && (
        <Icon data-feather={icon} themeStyle={theme} textColor={textColor} />
      )}
      <p>{text}</p>
    </StyledLink>
  );
};

export default FPLink;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 0.5rem;
  border-radius: 50px;
  padding: 6px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  width: ${({ width }) => width};
  max-width: 600px;
  transition: background 0.3s ease, color 0.3s ease, transform 0.2s ease-in-out;
  text-decoration: none;

  color: ${({ textColor, themeStyle }) =>
    textColor || (themeStyle === "dark" ? "white" : "black")};

  background: ${({ background }) => background || "transparent"};

  border: ${({ outlined, themeStyle }) =>
    outlined
      ? `1px solid ${themeStyle === "dark" ? "white" : "black"}`
      : "1px solid transparent"};

  &:hover {
    background: ${({ themeStyle, background }) =>
      background
        ? background
        : themeStyle === "dark"
        ? "rgba(255, 255, 255, 0.3)"
        : "rgba(0,0,0,0.05)"};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const Icon = styled.i`
  width: 16px;
  height: 16px;
  color: ${({ textColor, themeStyle }) =>
    textColor || (themeStyle === "dark" ? "white" : "black")};
`;
